export class SlideZoomControls {
  constructor (image) {
    this.image = image
    this.activateZoom = this.activateZoom.bind(this)
    this.deactivateZoom = this.deactivateZoom.bind(this)
    this.moveZoom = this.moveZoom.bind(this)
    this.enable()
  }

  enable () {
    this.image.addEventListener('click', this.activateZoom)
    this.image.classList.add('media-slider__image--with-zoom')
  }

  activateZoom () {
    this.image.removeEventListener('click', this.activateZoom)
    this.image.parentElement.addEventListener('mousemove', this.moveZoom)
    document.addEventListener('click', this.deactivateZoom, true)
    this.image.classList.add('media-slider__image--zooming')
  }

  moveZoom (event) {
    const imageContainerRect = this.image.parentElement.getBoundingClientRect()
    const [mouseX, mouseY] = [
      event.clientX - imageContainerRect.left,
      event.clientY - imageContainerRect.top
    ]
    const percentX = (mouseX / this.image.width) * 100
    const percentY = (mouseY / this.image.height) * 100
    this.image.style.transformOrigin = `${percentX}% ${percentY}%`
  }

  deactivateZoom (event) {
    event.stopImmediatePropagation()
    this.image.classList.remove('media-slider__image--zooming')
    this.image.style.transformOrigin = 'center'
    document.removeEventListener('click', this.deactivateZoom, true)
    this.image.removeEventListener('mousemove', this.moveZoom)
    this.image.addEventListener('click', this.activateZoom)
  }
}
